/***
 * 基本插件类
 */
export default class BaseAddon {
  // 处理跳转
  handleRouterBeforeEach(to, from, next) {

    // || (to.path === '/login' || to.path === '/login/index') || (to.path === '/register' || to.path === '/register/index')
    if (to.path === '/error' || (to.path === '/login' || to.path === '/login/index') || (to.path === '/register' || to.path === '/register/index')) {
      return next()
    } else {
      // 未找到对应的用户信息的话，跳转去登录页面
      let userInfo = global.myStore.get(global.myStore.staticName.USER_INFO)
      if (!userInfo || !userInfo.id) {
        if (to.fullPath.indexOf('register_store_no') > -1)
          return next('/register')
        else
          return next('/login')
      } else {
        return next()
      }
    }
  }
  // 页面加载完成
  pageReady() {

  }
  /**
   * 获取用户信息集 (页面打开时候获取用户信息)
   */
  getInitUserInfo(that, obj) {
    let memberInfo = global.myStore.get(global.myStore.staticName.USER_INFO)
    if (!obj.isRefresh && memberInfo && memberInfo.id && memberInfo.member_mobile && memberInfo.member_mobile !== '----') {
      // 不刷新用户信息并存在用户信息
      that.$store.dispatch('updateUserInfo', memberInfo)
      return new Promise(function (resolve) {
        resolve(memberInfo)
      })
    }
    console.log('2222', global.tools, global.myStore)
    return global.tools.getMemberInfo(that, obj)
  }
}



// WEBPACK FOOTER //
// ./src/utils/tools/addon/baseAddon.js